import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { ViptelaApiSettingsDefaults } from './types';

export const unreachableDeviceMaxRetry = {
  defaultValue: 3,
  boundaryValues: {
    min: 0,
    max: 5,
  },
};

export const unreachableDeviceBaseDelaySec = {
  defaultValue: 30,
  boundaryValues: {
    min: 10,
    max: 60,
  },
};

const dataErrorHandlingSettings = {
  unreachableDeviceMaxRetry: unreachableDeviceMaxRetry.defaultValue,
  unreachableDeviceBaseDelaySec: unreachableDeviceBaseDelaySec.defaultValue,
};

export const viptelaDefaults: ViptelaApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  ...dataErrorHandlingSettings,
  maxConcurrentRequests: 25,
  ompRoutesReceivedPrefixRequestLimit: 100,
  defaultSessionTimeoutSec: 30 * 60, // 30 minutes
  sessionInactivityTimeoutSec: 600,
  sessionInactivityTimeoutSafetyFactorPct: 75,
  combinedDiscovery: false,
  deviceTimeoutLimit: 2,
};
